import {EventBroker} from "@frontend/lib/utils/event-broker";

export const CATALOG_MANAGEMENT_EVENTS = {
  INIT: 'INIT'
}

export const catalogManagementEventBroker = new EventBroker()